import "./graph.css";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
} from "recharts";

const data = [
  {
    name: "90-100%",
    ourStudents: 65,
    stateAverage: 15,
  },
  {
    name: "80-89%",
    ourStudents: 25,
    stateAverage: 30,
  },
  {
    name: "70-79%",
    ourStudents: 8,
    stateAverage: 35,
  },
  {
    name: "Below 60%",
    ourStudents: 2,
    stateAverage: 6,
  },
];

const dataSecond = [
  {
    name: "90-100%",
    ourStudents: 53,
    stateAverage: 15,
  },
  {
    name: "80-89%",
    ourStudents: 25,
    stateAverage: 30,
  },
  {
    name: "70-79%",
    ourStudents: 8,
    stateAverage: 35,
  },
  {
    name: "Below 60%",
    ourStudents: 2,
    stateAverage: 6,
  },
];

const Graph = () => {
  return (
    <>
      <div className="ultimate-chart-container">
        <div className="two-charts-container">
          <div
            style={{ width: "98%", height: "400px" }}
            className="chart-container"
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Board Exam Results (2023-24)
            </h2>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{
                  top: 0,
                  right: 2,
                  left: 2,
                  bottom: 100,
                }}
                barGap={0}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />{" "}
                <h4>Percentage of Students</h4>
                <XAxis dataKey="name" tick={{ fontSize: 14 }} />
                <YAxis
                  type="number"
                  domain={[0, 80]}
                  ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80]}
                  tickFormatter={(value) => `${value}%`}
                  tick={{ fontSize: 16 }}
                />
                <Tooltip formatter={(value) => `${value}%`} />
                <Legend
                  verticalAlign="top"
                  height={10}
                  wrapperStyle={{ paddingBottom: "20px" }}
                />
                <Bar
                  dataKey="ourStudents"
                  name="Our Students"
                  fill="#FF8C5B"
                  radius={[16, 16, 0, 0]}
                ></Bar>
                <Bar
                  dataKey="stateAverage"
                  name="State Average"
                  fill="#28B7FF"
                  radius={[16, 16, 0, 0]}
                ></Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div
            style={{ width: "98%", height: "400px" }}
            className="chart-container"
          >
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Board Exam Results (2024-25)
            </h2>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={dataSecond}
                margin={{
                  top: 0,
                  right: 2,
                  left: 2,
                  bottom: 100,
                }}
                barGap={0}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="name" tick={{ fontSize: 14 }} />
                <YAxis
                  type="number"
                  domain={[0, 70]}
                  ticks={[0, 10, 20, 30, 40, 50, 60, 70]}
                  tickFormatter={(value) => `${value}%`}
                  tick={{ fontSize: 16 }}
                />
                <Tooltip formatter={(value) => `${value}%`} />
                <Legend
                  verticalAlign="top"
                  height={10}
                  wrapperStyle={{ paddingBottom: "20px" }}
                />
                <Bar
                  dataKey="ourStudents"
                  name="Our Students"
                  fill="#FF8C5B"
                  radius={[16, 16, 0, 0]}
                ></Bar>
                <Bar
                  dataKey="stateAverage"
                  name="State Average"
                  fill="#28B7FF"
                  radius={[16, 16, 0, 0]}
                ></Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="chart-cards-container">
          <div className="chart-card">
            <h2 className="chart-card-header">95%</h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                margin: "5px 0 10px 0",
              }}
            >
              Students Scored Above 90% in Board Exam
            </p>
          </div>
          <div className="chart-card">
            <h2 className="chart-card-header">85+</h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                margin: "5px 0 10px 0",
              }}
            >
              Students Qualified for National Competition
            </p>
          </div>
          <div className="chart-card">
            <h2 className="chart-card-header">25%</h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                margin: "5px 0 10px 0",
              }}
            >
              Average Improvement in Student Scores
            </p>
          </div>
          <div className="chart-card">
            <h2 className="chart-card-header">100%</h2>
            <p
              style={{
                textAlign: "center",
                fontSize: "clamp(12px, 2.5vw, 14px)",
                margin: "5px 0 10px 0",
              }}
            >
              Pass Rate for all classes
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Graph;
